"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlertDeleteHandler = void 0;
// (C) 2021 GoodData Corporation
var react_1 = require("react");
var internal_1 = require("../../../hooks/internal");
var contexts_1 = require("../../../contexts");
function useAlertDeleteHandler(_a) {
    var closeAlertDialog = _a.closeAlertDialog, backend = _a.backend, workspace = _a.workspace;
    var removeAlert = contexts_1.useAlerts().removeAlert;
    var _b = react_1.useState(undefined), alertToDelete = _b[0], setAlertToDelete = _b[1];
    var deleteAlert = function (alert) { return setAlertToDelete(alert); };
    var _c = react_1.useState("idle"), alertDeletingStatus = _c[0], setAlertDeletingStatus = _c[1];
    internal_1.useDeleteWidgetAlert({
        backend: backend,
        workspace: workspace,
        widgetAlert: alertToDelete,
        onError: function () {
            setAlertDeletingStatus("error");
            setAlertToDelete(undefined);
        },
        onLoading: function () { return setAlertDeletingStatus("inProgress"); },
        onSuccess: function () {
            setAlertDeletingStatus("idle");
            removeAlert(alertToDelete);
            setAlertToDelete(undefined);
            closeAlertDialog();
        },
    });
    return {
        alertDeletingStatus: alertDeletingStatus,
        deleteAlert: deleteAlert,
    };
}
exports.useAlertDeleteHandler = useAlertDeleteHandler;
//# sourceMappingURL=useAlertDeleteHandler.js.map